import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Download.css";
import pdf from "../../../images/pdf.png";
import excel from "../../../images/excel.png";
import word from "../../../images/word.png";
import xml from "../../../images/imgxml.png";
import URLstateContext from "../../../provider/CommonContext";
import { GetPostMethodData, DecryptAESdata } from "../../../provider/ServiceProvider";
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Button from "@mui/material/Button";

function Download() {
  const [data, setData] = useState(false);
  const [section, setsection] = useState(5);
  const { BaseURL } = useContext(URLstateContext);
  const arrayOfTabsObj = [
    { name: "Fund Fact Sheets", id: 5 },
    { name: "PMS Related Documents", id: 9 },
    { name: "Application form", id: 2 },
    { name: "Scheme Related Documents", id: 11 }
  ];


  const handleChange = (event, newValue) => {
    setsection(newValue);

    GetPostMethodData(BaseURL + "GetDownloadsById", {
      CategoryId: newValue,
      top: "6",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
      }
    });
  };


  useEffect(() => {
    GetPostMethodData(BaseURL + "GetDownloadsById", {
      CategoryId: section,
      top: "6",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
      }
    });
  }, [BaseURL, section]);

  return (
    <>
      <section className="download-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="download-pnl trending-pnl">
                <div className="section-header">
                  <h2>Downloads</h2>
                </div>

                <Box sx={{ paddingLeft: 5 }}>
                  <TabContext value={section}>
                    <Box
                      sx={{
                        borderBottom: 0,
                        borderColor: "divider",
                        width: "100%",
                        paddingLeft: "10%"
                      }}

                    >
                      <TabList
                        onChange={handleChange}
                        variant="scrollable"
                        sx={{
                          [`& .${tabsClasses.scrollButtons}`]: {
                            "&.Mui-disabled": { opacity: 0.3 },
                          },

                        }}
                        scrollButtons="auto"

                      >
                        {arrayOfTabsObj.map((item) => (
                          <Tab label={item.name} value={item.id}></Tab>
                        ))}
                      </TabList>
                    </Box>
                    <div className="height30"></div>
                    {arrayOfTabsObj.map((item) => (
                      <TabPanel value={item.id}>
                        {data &&
                          data.map(
                            ({ heading, category, filename, fileext }) => (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={BaseURL.replace("api/", "") + filename}
                                download
                                className="pointer"
                              >
                                <div className="update-main">
                                  <div className="update-data">
                                    <h6>{category}</h6>
                                    <h4>{heading}</h4>
                                  </div>

                                  <div className="pdf-img">

                                    {fileext.toLowerCase() === ".pdf" ? (
                                      <img
                                        src={pdf}
                                        alt="pdf"
                                        className="img-fluid"
                                      />
                                    ) : fileext.toLowerCase() === ".xls" ||
                                      fileext.toLowerCase() === ".xlsx" ? (
                                      <img
                                        src={excel}
                                        alt="Excel"
                                        className="img-fluid"
                                      />
                                    ) : fileext.toLowerCase() === ".xml" ? (
                                      <img
                                        src={xml}
                                        alt="XML"
                                        className="img-fluid"
                                      />
                                    ) : (
                                      <img
                                        src={word}
                                        alt="Word"
                                        className="img-fluid"
                                      />
                                    )}

                                  </div>
                                </div>
                              </a>
                            )
                          )}
                      </TabPanel>
                    ))}

                  </TabContext>
                </Box>
              </div>

              {/* <div className="show-all">
             
                <Button variant="contained"> <a href="/Downloads" className="btn-ourfund">Show All</a></Button>
               
                </div> */}
              <div className="know-more-fund-button-blog">
                <a href="/Downloads" className="btn-ourfund" aria-label="show all downloads">Show All</a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Download;
